<!--
 * @Description: 中企出海
-->
<template>
  <Layout>
    <div class="go_overseas">
      <section class="go_header"
      :class="{ 'go_header_en': $i18n.locale === 'en_US' }">
        <div class="go_header_card">
          <div class="header_content">
            <div class="header_img">
              <div>{{ $t("overseas.header.icon01") }}</div>
              <div>{{ $t("overseas.header.icon02") }}</div>
            </div>
            <div
              class="header_title"
              :class="{ 'header_title_en': $i18n.locale === 'en_US' }"
            >
              {{ $t("overseas.header.title") }}
            </div>
          </div>
          <div class="mt--30">
            <ul>
              <li>{{ $t("overseas.header.description01") }}</li>
              <li>{{ $t("overseas.header.description02") }}</li>
              <li>{{ $t("overseas.header.description03") }}</li>
            </ul>
          </div>
        </div>
      </section>
      <!-- 汉得微扬能力为中企出海保驾护航 -->
      <section class="rn-section-gap go_capacity go_overseas">
        <div class="container">
          <div class="row">
            <SectionTitle
              :title="$t('overseas.departure_service.title')"
              description="HAND DEPARTURE SERVICE"
              textAlign="center"
            />
            <div class="go_capacity_card mt--30">
              <div class="row gx-5">
                <div
                  class="col-lg-3 col-md-4 col-sm-6 col-12 p-5"
                  v-for="item in capacityList"
                  :key="item.id"
                >
                  <div class="capacity_card_image">
                    <div class="capacity_card_img">
                      <img :src="item.img" />
                    </div>
                  </div>
                  <div class="capacity_title go_overseas first_title">
                    {{ item.title }}
                  </div>
                  <div class="capacity_desc go_overseas second_title">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新形势下中企出海趋势与挑战 -->
      <section class="go_challenge">
        <div class="container">
          <div class="row align-items-center">
            <div class="challenge_content col-lg-6 col-md-6 col-sm-12 col-12">
              <SectionTitle
                class="challenge_title"
                :title="$t('overseas.trends_and_challenges.title')"
                description="TRENDS AND CHALLENGES"
                textAlign="left"
              />
              <div class="challenge_desc go_overseas second_title">
                {{ $t("overseas.trends_and_challenges.description") }}
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div>
                <div class="challenge_img" :class="{ 'challenge_img_en': $i18n.locale === 'en_US' }">
                  <div class="challenge_card card_01 card_01_en" >
                    {{
                      $t("overseas.trends_and_challenges.content.challenges01")
                    }}
                  </div>
                  <div class="challenge_card card_02 card_02_en">
                    {{
                      $t("overseas.trends_and_challenges.content.challenges02")
                    }}
                  </div>
                  <div class="challenge_card card_03 card_03_en">
                    {{
                      $t("overseas.trends_and_challenges.content.challenges03")
                    }}
                  </div>
                  <div
                    class="challenge_card card_text card_04 go_overseas ul_list card_04_en"
                  >
                    <ul>
                      <li>
                        {{
                          $t(
                            "overseas.trends_and_challenges.content.challenges04"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "overseas.trends_and_challenges.content.challenges05"
                          )
                        }}
                      </li>
                    </ul>
                  </div>
                  <div class="challenge_card card_text card_05 card_05_en">
                    {{
                      $t("overseas.trends_and_challenges.content.challenges06")
                    }}
                  </div>
                  <div
                    class="challenge_card card_text card_06 go_overseas ul_list card_06_en"
                  >
                    <ul>
                      <li>
                        {{
                          $t(
                            "overseas.trends_and_challenges.content.challenges07"
                          )
                        }}
                      </li>
                      <li>
                        {{
                          $t(
                            "overseas.trends_and_challenges.content.challenges08"
                          )
                        }}
                      </li>
                    </ul>
                  </div>
                  <img
                    src="../../assets/images/goOverseas/challenge-background-img.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 海外实施主要难点和风险总结 -->
      <section class="go_summarize go_overseas rn-section-gap">
        <div class="container">
          <SectionTitle
            :title="$t('overseas.difficulties_and_risks.title')"
            description="DIFFICULTIES AND RISKS"
            textAlign="center"
          />
          <div class="go_summarize_card">
            <div class="row g-5">
              <div
                class="col-lg-6 col-md-6 col-sm-12 col-12 summarize_card"
                v-for="item in summarizeList"
                :key="item.id"
              >
                <div class="summarize_card_content">
                  <div class="summarize_card_image go_overseas card_image">
                    <div class="summarize_card_img">
                      <img :src="item.img" />
                    </div>
                  </div>
                  <div class="summarize_content">
                    <div
                      class="summarize_content_title go_overseas first_title"
                    >
                      {{ item.title }}
                    </div>
                    <div class="go_overseas ul_list">
                      <ul>
                        <li v-for="ite in item.desc" :key="ite.id">
                          {{ ite.title }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card_middle">
              <div class="card_middle_title">DIFFICULTIES<br />&RISKS</div>
            </div>
          </div>
        </div>
      </section>
      <!-- 为什么选择我们 -->
      <whyChooseUs />
      <!-- 中企出海地区服务特色 -->
      <section class="go_serve go_overseas rn-section-gap">
        <div class="container">
          <div class="mb--20">
            <SectionTitle
              :title="$t('overseas.features.title')"
              description="REGIONAL SERVICE FEATURES"
              textAlign="center"
            />
            <p class="go_serve_desc">
              {{ $t("overseas.features.description01") }}
            </p>
            <p class="go_serve_desc">
              {{ $t("overseas.features.description02") }}
            </p>
          </div>
          <div class="go_serve_content">
            <div
              v-for="item in serveList"
              :key="item.id"
              class="row mb--30 serve_card"
            >
              <div class="col-lg-4 col-md-4 col-sm-12 col-12 pr--50 pr_sm--0">
                <div
                  v-for="iList in item.list"
                  :key="iList.id"
                  :class="
                    iList.desc ? 'left_card checked mb--20' : 'left_card mb--20'
                  "
                >
                  <div>{{ iList.title }}</div>
                  <div v-if="iList.desc" class="checked_desc">
                    {{ iList.desc }}
                  </div>
                </div>
              </div>
              <div class="serve_right_card col-lg-8 col-md-8 col-sm-12 col-12">
                <div class="row">
                  <div
                    v-for="iData in item.data"
                    :key="iData.id"
                    :class="
                      item.id === 3 && iData.id === 3
                        ? 'col-lg-12 col-md-12 col-sm-12 col-12 p-4 card_content'
                        : 'col-lg-6 col-md-6 col-sm-12 col-12  p-4 card_content'
                    "
                  >
                    <div class="serve_icon_title">
                      <div class="serve_icon">
                        <img
                          class="serve_icon_img"
                          src="../../assets/images/goOverseas/serve-icon.png"
                        />
                      </div>
                      <div class="serve_title go_overseas first_title">
                        {{ iData.title }}
                      </div>
                    </div>
                    <div>
                      <div
                        v-if="item.id !== 3"
                        class="serve_desc go_overseas second_title"
                      >
                        {{ iData.desc }}
                      </div>
                      <div
                        v-else-if="iData.id !== 3"
                        class="serve_desc go_overseas ul_list"
                      >
                        <ul>
                          <li v-for="iDesc in iData.desc" :key="iDesc.id">
                            {{ iDesc.title }}
                          </li>
                        </ul>
                      </div>
                      <div v-else class="serve_desc_country">
                        <div
                          v-for="iDesc in iData.desc"
                          :key="iDesc.id"
                          class="row row-cols-2 serve_desc_card"
                        >
                          <div
                            class="col-2 serve_desc_title go_overseas second_title"
                          >
                            {{ iDesc.title }}
                          </div>
                          <div class="col-10">
                            <div class="row">
                              <div
                                v-for="content in iDesc.content"
                                :key="content.id"
                                :class="
                                  iDesc.id === 1
                                    ? 'serve_desc_img col'
                                    : 'serve_desc_img2 col'
                                "
                              >
                                <img v-if="content.img" :src="content.img" />
                                <div
                                  v-if="content.title"
                                  class="serve_desc_title go_overseas second_title"
                                >
                                  {{ content.title }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import whyChooseUs from '../../views/aboutUs/whyChooseUs.vue'

export default {
  name: 'goOverseasIndex',
  components: { Layout, SectionTitle, whyChooseUs },
  data () {
    return {
      capacityList: [
        { id: 1, img: require('@/assets/images/goOverseas/capacity-01.png'), title: this.$t('overseas.departure_service.tab01.title'), desc: this.$t('overseas.departure_service.tab01.description') },
        { id: 2, img: require('@/assets/images/goOverseas/capacity-02.png'), title: this.$t('overseas.departure_service.tab02.title'), desc: this.$t('overseas.departure_service.tab02.description') },
        { id: 3, img: require('@/assets/images/goOverseas/capacity-03.png'), title: this.$t('overseas.departure_service.tab03.title'), desc: this.$t('overseas.departure_service.tab03.description') },
        { id: 4, img: require('@/assets/images/goOverseas/capacity-04.png'), title: this.$t('overseas.departure_service.tab04.title'), desc: this.$t('overseas.departure_service.tab04.description') },
      ],
      summarizeList: [
        {
          id: 1, img: require('@/assets/images/goOverseas/summarize-01.png'), title: this.$t('overseas.difficulties_and_risks.tab01.title'),
          desc: [
            { id: 1, title: this.$t('overseas.difficulties_and_risks.tab01.description01') },
            { id: 2, title: this.$t('overseas.difficulties_and_risks.tab01.description02') },
            { id: 3, title: this.$t('overseas.difficulties_and_risks.tab01.description03') },
            { id: 4, title: this.$t('overseas.difficulties_and_risks.tab01.description04') },
            { id: 5, title: this.$t('overseas.difficulties_and_risks.tab01.description05') }
          ]
        },
        {
          id: 2, img: require('@/assets/images/goOverseas/summarize-02.png'), title: this.$t('overseas.difficulties_and_risks.tab02.title'),
          desc: [
            { id: 1, title: this.$t('overseas.difficulties_and_risks.tab02.description01') },
            { id: 2, title: this.$t('overseas.difficulties_and_risks.tab02.description02') },
            { id: 3, title: this.$t('overseas.difficulties_and_risks.tab02.description03') },
            { id: 4, title: this.$t('overseas.difficulties_and_risks.tab02.description04') },
            { id: 5, title: this.$t('overseas.difficulties_and_risks.tab02.description05') }
          ]
        },
        {
          id: 3, img: require('@/assets/images/goOverseas/summarize-03.png'), title: this.$t('overseas.difficulties_and_risks.tab03.title'),
          desc: [
            { id: 1, title: this.$t('overseas.difficulties_and_risks.tab03.description01') },
            { id: 2, title: this.$t('overseas.difficulties_and_risks.tab03.description02') },
            { id: 3, title: this.$t('overseas.difficulties_and_risks.tab03.description03') },
            { id: 4, title: this.$t('overseas.difficulties_and_risks.tab03.description04') }
          ]
        },
        {
          id: 4, img: require('@/assets/images/goOverseas/summarize-04.png'), title: this.$t('overseas.difficulties_and_risks.tab04.title'),
          desc: [
            { id: 1, title: this.$t('overseas.difficulties_and_risks.tab04.description01') },
            { id: 2, title: this.$t('overseas.difficulties_and_risks.tab04.description02') },
            { id: 3, title: this.$t('overseas.difficulties_and_risks.tab04.description03') },
            { id: 4, title: this.$t('overseas.difficulties_and_risks.tab04.description04') },
            { id: 5, title: this.$t('overseas.difficulties_and_risks.tab04.description05') }
          ]
        },
      ],
      serveList: [
        {
          id: 1,
          list: [
            { id: 1, title: this.$t('overseas.features.content.area01.title'), desc: this.$t('overseas.features.content.area01.description') },
            { id: 2, title: this.$t('overseas.features.content.area02.title') },
            { id: 3, title: this.$t('overseas.features.content.area03.title') }
          ],
          data: [
            { id: 1, title: this.$t('overseas.features.content.area01.content.tab01.title'), desc: this.$t('overseas.features.content.area01.content.tab01.description') },
            { id: 2, title: this.$t('overseas.features.content.area01.content.tab02.title'), desc: this.$t('overseas.features.content.area01.content.tab02.description') },
            { id: 3, title: this.$t('overseas.features.content.area01.content.tab03.title'), desc: this.$t('overseas.features.content.area01.content.tab03.description') },
            { id: 4, title: this.$t('overseas.features.content.area01.content.tab04.title'), desc: this.$t('overseas.features.content.area01.content.tab04.description') },
            { id: 5, title: this.$t('overseas.features.content.area01.content.tab05.title'), desc: this.$t('overseas.features.content.area01.content.tab05.description') },
            { id: 6, title: this.$t('overseas.features.content.area01.content.tab06.title'), desc: this.$t('overseas.features.content.area01.content.tab06.description') },
          ]
        },
        {
          id: 2,
          list: [
            { id: 1, title: this.$t('overseas.features.content.area01.title') },
            { id: 2, title: this.$t('overseas.features.content.area02.title'), desc: this.$t('overseas.features.content.area02.description') },
            { id: 3, title: this.$t('overseas.features.content.area03.title') }
          ],
          data: [
            { id: 1, title: this.$t('overseas.features.content.area02.content.tab01.title'), desc: this.$t('overseas.features.content.area02.content.tab01.description') },
            { id: 2, title: this.$t('overseas.features.content.area02.content.tab02.title'), desc: this.$t('overseas.features.content.area02.content.tab02.description') },
            { id: 3, title: this.$t('overseas.features.content.area02.content.tab03.title'), desc: this.$t('overseas.features.content.area02.content.tab03.description') },
            { id: 4, title: this.$t('overseas.features.content.area02.content.tab04.title'), desc: this.$t('overseas.features.content.area02.content.tab04.description') },
            { id: 5, title: this.$t('overseas.features.content.area02.content.tab05.title'), desc: this.$t('overseas.features.content.area02.content.tab05.description') },
            { id: 6, title: this.$t('overseas.features.content.area02.content.tab06.title'), desc: this.$t('overseas.features.content.area02.content.tab06.description') },
            { id: 7, title: this.$t('overseas.features.content.area02.content.tab07.title'), desc: this.$t('overseas.features.content.area02.content.tab07.description') },
          ]
        },
        {
          id: 3,
          list: [
            { id: 1, title: this.$t('overseas.features.content.area01.title') },
            { id: 2, title: this.$t('overseas.features.content.area02.title') },
            { id: 3, title: this.$t('overseas.features.content.area03.title'), desc: this.$t('overseas.features.content.area03.description') }
          ],
          data: [
            {
              id: 1, title: this.$t('overseas.features.content.area03.content.tab01.title'),
              desc: [
                { id: 1, title: this.$t('overseas.features.content.area03.content.tab01.description01') },
                { id: 2, title: this.$t('overseas.features.content.area03.content.tab01.description02') },
                { id: 3, title: this.$t('overseas.features.content.area03.content.tab01.description03') }
              ]
            },
            {
              id: 2, title: this.$t('overseas.features.content.area03.content.tab02.title'),
              desc: [
                { id: 1, title: this.$t('overseas.features.content.area03.content.tab02.description01') },
                { id: 2, title: this.$t('overseas.features.content.area03.content.tab02.description02') },
                { id: 3, title: this.$t('overseas.features.content.area03.content.tab02.description03') }
              ]
            },
            {
              id: 3, title: this.$t('overseas.features.content.area03.content.tab03.title'),
              desc: [
                {
                  id: 1, title: '',
                  content: [
                    { id: 1, title: this.$t('overseas.features.content.area03.content.tab03.country01'), img: require('@/assets/images/goOverseas/serve-country-01.png') },
                    { id: 2, title: this.$t('overseas.features.content.area03.content.tab03.country02'), img: require('@/assets/images/goOverseas/serve-country-02.png') },
                    { id: 3, title: this.$t('overseas.features.content.area03.content.tab03.country03'), img: require('@/assets/images/goOverseas/serve-country-03.png') },
                    { id: 4, title: this.$t('overseas.features.content.area03.content.tab03.country04'), img: require('@/assets/images/goOverseas/serve-country-04.png') },
                    { id: 5, title: this.$t('overseas.features.content.area03.content.tab03.country05'), img: require('@/assets/images/goOverseas/serve-country-05.png') },
                    { id: 6, title: this.$t('overseas.features.content.area03.content.tab03.country06'), img: require('@/assets/images/goOverseas/serve-country-06.png') },
                    { id: 7, title: this.$t('overseas.features.content.area03.content.tab03.country07'), img: require('@/assets/images/goOverseas/serve-country-07.png') }]
                },
                {
                  id: 2, title: this.$t('overseas.features.content.area03.content.tab03.capacity01'),
                  content: [
                    { id: 1, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 2, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 3, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 4, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 5, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 6, img: require('@/assets/images/goOverseas/serve-01.png') },
                    { id: 7, img: require('@/assets/images/goOverseas/serve-01.png') }]
                },
                {
                  id: 3, title: this.$t('overseas.features.content.area03.content.tab03.capacity02'),
                  content: [
                    { id: 1, img: require('@/assets/images/goOverseas/serve-02.png') },
                    { id: 2, img: require('@/assets/images/goOverseas/serve-02.png') },
                    { id: 3, img: require('@/assets/images/goOverseas/serve-02.png') },
                    { id: 4, img: require('@/assets/images/goOverseas/serve-02.png') },
                    { id: 5, img: '' },
                    { id: 6, img: '' },
                    { id: 7, img: '' }]
                }
              ]
            }
          ]
        }
      ],
    }
  },
  methods: {
 
  }
}
</script>